import(/* webpackMode: "eager" */ "/source/node_modules/.pnpm/next@14.2.30_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-_32b6b149ba5392b175875df5addd8cd3/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/source/node_modules/.pnpm/next@14.2.30_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-_32b6b149ba5392b175875df5addd8cd3/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/source/node_modules/.pnpm/react-error-boundary@4.1.2_react@18.3.1/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/[pageCode]/BgColor.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/BrandsBig/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/BrandsSmall/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/CategoryBig/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/CategorySmall/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/contentLand/cartLayer.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/contentLand/ClientLogicHandler.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/contentLand/content.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/contentLand/StockDialog.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/one-row-left-horizontal-product/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/product-h5-floor/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/two-row-left-horizontal-product/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-announcement/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-anchor/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-auction-enter/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-banner-m/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-best-sellerV2/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-carousel-small/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/components/countDownBar.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/components/couponContent.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/components/couponList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/icons/SVGScrollController.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/icons/WatermarkAllClaimed.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/icons/WatermarkCollected.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/icons/WatermarkEnded.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/icons/WatermarkNotStarted.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/cate-demo.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/category-demo.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/image-demo.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/next.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/prav.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/img/test-demo.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/CountdownTimer.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/flashSalesClient.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/products.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/productSwiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/textSwiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/timer.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-happy-hour/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-happy-hour/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-horizontal-pool/component/productList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-hotspot/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-image-ads/components/campaign.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-image/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-mental/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-new-arrival/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer-gift/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/AlmostSoldout.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/ArrowRightBlack.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/default_white.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/default.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/icon.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/img/newcomer-title.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-popular-categoryV2/component/category.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/Empty/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/img/error-img.png");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/ProductCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/ProductImg/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/component/MyReservation.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/back.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/calendar.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/dot.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/fire.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flash.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flashCN.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flashDE.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flashFR.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flashNL.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/flashTW.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/icon/rulesInfo.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-titlebar-static/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-titlebar/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-two-row-pool/component/productList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-big/component/productCard.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-big/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-small/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-small/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-big/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/up-horizontal-product-big/component/productCard.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-miniHome/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-two-row-pool/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-two-row-pool/component/productList.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-titlebar/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-titlebar-static/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-title/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-seckill-happy-hour/component/MyReservation.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-recommend-product/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/ProductImg/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/ProductCard/index.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-product-activity/compoments/Empty/index.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-popular-categoryV2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-newcomer-gift/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-new-arrival/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-mental/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-image/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-image-ads/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-hotspot/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-horizontal-pool/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-home-small/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-horizontal-pool/component/productList.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-happy-hour/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-happy-hour/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-flash-sales/clientComponent/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-coupon/components/couponList.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-carousel-small/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-best-sellerV2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-banner-m/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-auction-enter/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-h5-anchor/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-announcement/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/two-row-left-horizontal-product/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/product-h5-floor/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/one-row-left-horizontal-product/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/global-setting/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/[pageCode]/cms.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/assets/icons/feedbackBlack.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTryAgain"] */ "/source/src/components/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/feedbackTrigger/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/gift/components/collect/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/OchamaMigTrack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/recommend/recommendClient.tsx");
